module.exports = __webpack_public_path__ + "img/01-xl.87ecaef.webp";